export const mondayLocale = $localize`:Date|Day monday label@@dayMondayLabel:Monday`;
export const tuesdayLocale = $localize`:Date|Day tuesday label@@dayTuesdayLabel:Tuesday`;
export const wednesdayLocale = $localize`:Date|Day wednesday label@@dayWednesdayLabel:Wednesday`;
export const thursdayLocale = $localize`:Date|Day thursday label@@dayThursdayLabel:Thursday`;
export const fridayLocale = $localize`:Date|Day friday label@@dayFridayLabel:Friday`;
